"use client";

import ProductPage from "@/components/ProductPage";
import { KassensystemHardwareSection } from "@/components/KassensystemHardwareSection";
import ImageHero from "./Bctx.webp";
import ImageHighlight from "./highlight.jpg";
import ImageFeatureEC from "./feature-ec.jpg";
import ImageFeatureCustomers from "./feature-customers.jpg";
import ImageFeatureStock from "./feature-stock.jpg";
import ImageFeatureStats from "./feature-stats.jpg";
import ImageFeatureOrder from "./feature-order.jpg";
import ImageFeatureExport from "./feature-export.jpg";

export default function Cashtex() {
  return (
    <ProductPage
      productName={"CASHTEX - Kassensystem für den Textileinzelhandel"}
      hero={{
        image: ImageHero,
        imageAlt: "Cashtex",
        title: "CASHTEX - Kassensystem für den Textileinzelhandel",
        subtitle:
          "Optimiert für Boutiquen, Modehäuser und Filialen - alles in einem System.",
        bullets: [
          "Effiziente Verkaufsprozesse & schnelle Abwicklung",
          "Intuitive Artikel- & Kundenverwaltung",
          "Klare Umsatzanalysen & Berichte in Echtzeit",
          "Optimiert für Boutiquen, Modehäuser & Filialen",
          "Alles in einem System - einfach & zuverlässig",
          "GoBD-konform & revisionssicher",
        ],
        buttonLeft: {
          title: "Cashtex anfragen",
          href: "/support?produkt=Cashtex",
        },
        buttonRight: {
          title: "Hardware kaufen",
          href: "/hardware",
        },
      }}
      highlight={{
        image: ImageHighlight,
      }}
      spacer={
        <>
          Optimieren Sie Ihr <b>Textilgeschäft</b> mit Cashtex. Von{" "}
          <b>schnellen Zahlungen</b> über die einfache Verwaltung von Größen,
          Farben und Artikeln bis hin zu Umsatzstatistiken in Echtzeit - Cashtex
          wurde speziell für den Textileinzelhandel entwickelt. Unser
          Kassensystem vereinfacht Ihre Abläufe,{" "}
          <b>reduziert Verwaltungsaufwand</b> und steigert die Effizienz Ihres
          Geschäfts.
        </>
      }
      features={[
        {
          src: ImageFeatureEC,
          alt: "EC Cash",
          title: "Schneller Verkauf & Kassenprozess",
          desc: "Quittungen, Retouren, Gutschriften, Lieferscheine und Belegdruck - reibungslos direkt an der Kasse.",
        },
        {
          src: ImageFeatureCustomers,
          alt: "EC Cash",
          title: "Kundenverwaltung",
          desc: "Bonusprogramme, Geburtstagsmodul, Serien-E-Mail/-Brief, Kundenkarten und Umsatzanalysen - alles zentral.",
        },
        {
          src: ImageFeatureStock,
          alt: "EC Cash",
          title: "Artikel- & Lagerverwaltung",
          desc: "Artikelstämme, Größen/Farben, Kollektionsbilder, Mehrpreisstufen, Barcode- & Etikettendruck, Inventur via Scanner.",
        },
        {
          src: ImageFeatureStats,
          alt: "EC Cash",
          title: "Verkaufsstatistiken",
          desc: "Renner-/Penner-Listen, Auswertungen nach Mitarbeitenden, Artikeln & Lieferanten - klare Entscheidungen treffen.",
        },
        {
          src: ImageFeatureOrder,
          alt: "EC Cash",
          title: "Bestellwesen & Wareneingang",
          desc: "Lieferantenbestellungen, Orderübersicht, Wareneingang per Scanner, Kontrolle offener Bestellungen.",
        },
        {
          src: ImageFeatureExport,
          alt: "EC Cash",
          title: "Kassenbuch & Export",
          desc: "Einnahmen/Ausgaben, revisionssicheres Kassenbuch, Exporte für DATEV/Lexware/FIBU - weniger Buchhaltungsaufwand.",
        },
      ]}
      faqs={[
        {
          q: "Unterstützt CASHTEX meine Hardware (Scanner, Drucker)?",
          a: "Ja. Gängige Barcodescanner, Bondrucker und Etikettendrucker werden unterstützt. Details klären wir im Onboarding.",
        },
        {
          q: "Für kleine Boutiquen bis Filialbetriebe geeignet?",
          a: "Ja. Die Lösung ist modular und skaliert von der Einzelkasse bis zu mehreren Filialen.",
        },
        {
          q: "Wie erfolgt der Export zum Steuerberater?",
          a: "Per DATEV/Lexware/FIBU-Export sowie GoBD-konformer Datenbereitstellung.",
        },
        {
          q: "Hilft CASHTEX bei der Inventur?",
          a: "Ja. Inventurlisten, Zählscheine und Scanner-Workflows vereinfachen die Bestandsaufnahme.",
        },
        {
          q: "Wie starte ich mit der Demoversion?",
          a: "Kontakt anfragen und in wenigen Schritten Zugang zur Demo erhalten.",
        },
      ]}
    >
      <KassensystemHardwareSection />
    </ProductPage>
  );
}
